import { flatten } from "@/common/helpers/array";

import { getImageField } from "./services/cms";

const allBlocks = flatten([
  getImageField("translations.image"),
  "translations.items.*",
  "translations.partners.*",
  "translations.items.item.*",
  getImageField("translations.items.icon"),
  getImageField("translations.items.image"),
  getImageField("translations.partners.image"),
  getImageField("translations.items.items.icon"),
]);

const seo = ["item.*", "item.og_image.filename_disk", "item.og_image.title"];
const blocks = [
  "item.collection.item.*",
  "item.collection.id",
  "item.collection.collection",
  "item.collection.item.translations.*",
  "item.collection.item.translations.items.items.*",
  ...allBlocks.map((populate) => `item.collection.item.${populate}`),
];
const promoBanner = [
  "item.*",
  "item.image.filename_disk",
  "item.image.title",
  "item.image_large.filename_disk",
  "item.image_large.title",
  "item.image_small.filename_disk",
  "item.image_small.title",
];

export const populate = {
  seo: seo.map((v) => `translations.seo.${v}`),
  blocks: blocks.map((v) => `blocks.${v}`),
  article: [
    "translations.article.id",
    "translations.article.collection",
    "translations.article.item.*",
    "translations.article.item.items.*",
    "translations.article.item.rows.*",
    "translations.article.item.author.*",
    "translations.article.item.bios.*",
    "translations.article.item.bios.author.*",
    "translations.article.item.bios.author.translations.*",
    getImageField("translations.article.item.image"),
    getImageField("translations.article.item.photo"),
    getImageField("translations.article.item.items.image"),
    getImageField("translations.article.item.author.photo"),
    getImageField("translations.article.item.bios.author.photo"),
  ],
  promoBanner: promoBanner.map((v) => `translations.promo_banner.${v}`),
};
